import React, { FunctionComponent, JSX } from "react";
import Icon from "@ant-design/icons";

import { IIcon } from "./icons-interfaces";


const SendPassSvg = () => (

	<svg fill="currentColor" width="1em" height="1em" viewBox="0 0 48 48" strokeWidth="1">
		<g>
			<path d="M42.1,25.3V9.7c0-0.1,0-0.1,0-0.1c0-0.1,0-0.2-0.1-0.3C42,9.2,42,9.1,41.9,9c0,0,0-0.1-0.1-0.1c0,0,0,0-0.1-0.1
		c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.2,0c0,0-0.1,0-0.1,0H5.2c0,0,0,0-0.1,0
		c-0.1,0-0.2,0-0.2,0.1c-0.1,0-0.2,0-0.2,0.1c-0.1,0-0.1,0.1-0.2,0.1C4.4,8.7,4.3,8.8,4.2,8.8c0,0,0,0-0.1,0c0,0,0,0.1-0.1,0.1
		C4.1,9.1,4,9.2,4,9.3C4,9.3,4,9.4,4,9.5c0,0.1,0,0.1,0,0.2V36c0,0.7,0.6,1.2,1.2,1.2h19.2c1.7,3.9,5.5,6.6,10,6.6
		c6,0,10.9-4.9,10.9-10.9C45.3,30,44.1,27.3,42.1,25.3z M37.2,10.9l-14.3,11l-14.1-11H37.2z M6.4,34.8V12.2l15.7,12.2
		c0.2,0.2,0.5,0.3,0.8,0.3c0.3,0,0.5-0.1,0.8-0.3l16-12.3v11.2c-1.6-0.9-3.4-1.4-5.3-1.4c-6,0-10.9,4.9-10.9,10.9
		c0,0.6,0.1,1.2,0.2,1.8H6.4z M34.4,41.4c-4.6,0-8.4-3.8-8.4-8.4c0-4.6,3.8-8.4,8.4-8.4s8.4,3.8,8.4,8.4
		C42.8,37.6,39,41.4,34.4,41.4z"/>
			<path d="M38.3,30.2H38v-0.6c0-2-1.6-3.6-3.6-3.6c-2,0-3.6,1.6-3.6,3.6v0.6h-0.3c-0.7,0-1.2,0.6-1.2,1.2v6.3c0,0.7,0.6,1.2,1.2,1.2
		h7.8c0.7,0,1.2-0.6,1.2-1.2v-6.3C39.5,30.8,39,30.2,38.3,30.2z M33.3,29.6c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1v0.6h-2.3
		V29.6z M37,36.5h-5.3v-3.8H37V36.5z"/>
		</g>
	</svg>

);

const SendPassIcon: FunctionComponent<IIcon> = (): JSX.Element => {
	return <Icon component={ SendPassSvg } />;
};


export default SendPassIcon;